import {
  type QueryFunctionContext,
  useInfiniteQuery,
} from '@tanstack/react-query'

import { useFetchArchivedDocumentImages } from '../useFetchArchivedDocumentImages'

import { useArchivedDocumentImagesInfiniteQueryKey } from './useArchivedDocumentImagesInfiniteQueryKey'

type QueryKey = ReturnType<typeof useArchivedDocumentImagesInfiniteQueryKey>
type PageParam = number

export const useArchivedDocumentImagesInfiniteQuery = () => {
  const fetchArchivedDocumentImages = useFetchArchivedDocumentImages()
  const queryKey = useArchivedDocumentImagesInfiniteQueryKey()

  return useInfiniteQuery({
    queryFn: ({
      pageParam: offset,
      queryKey: [_, variables],
    }: QueryFunctionContext<QueryKey, PageParam>) =>
      fetchArchivedDocumentImages({ ...variables, offset }),
    queryKey,
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages): PageParam | undefined =>
      0 < lastPage.length ? allPages.flat().length : undefined,
  })
}
